module.exports = __webpack_public_path__ + "static/media/bee.fa34bdb8.gif";